import Org from './org.vue';

export default Org;
